// extracted by mini-css-extract-plugin
export default {"container":"OurCurriculum_component_container__Pue5I","mainTitle":"OurCurriculum_component_mainTitle__Xg6jX","description":"OurCurriculum_component_description__9PkHU"};